import { OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from '../../dashboard';
import { Data } from '../../helpers';
import { LoginService } from '../../login';
import { PaymentHelper } from '../commons/helper/payment';
import { DateTimeConverstionService } from '../../services/index';
var RegisterSessionComponent = /** @class */ (function () {
    function RegisterSessionComponent(data, paymentHelper, dashboardService, router, route, loginService, timeZoneConverstionService) {
        this.data = data;
        this.paymentHelper = paymentHelper;
        this.dashboardService = dashboardService;
        this.router = router;
        this.route = route;
        this.loginService = loginService;
        this.timeZoneConverstionService = timeZoneConverstionService;
        this.query = '';
        this.courseDetail = {};
        this.creator = {};
        this.startTime = {};
        this.endTime = {};
        this.country = "";
        this.details = {};
        this.msgTitle = "";
        this.msgContent = "";
        this.acceptTC = false;
        this.popUp = false;
        this.loading = false;
        this.countryArr = [];
        this.selectedCountryId = '';
        this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
        this.showOnlyOverlay = false;
        this.showErrorMessageTitle = "";
        this.showErrorMessages = [];
        this.isValidationError = false;
        this.showErrorPopupWidthInPercentage = "100%";
        this.showErrorModalDialog = false;
        this.isSignUp = true;
        this.pleaseWait = true;
        this.questionnaireResponse = {};
        this.isPromoCode = false;
        this.couponCode = "";
        this.couponError = false;
        this.couponInvalid = false;
        this.couponData = {
            revisedAmount: 0,
            success: false
        };
        this.questionnaireResponse = JSON.parse(localStorage.getItem("questionnaireResponse"));
        console.log("this.questionnaireResponse", this.questionnaireResponse);
    }
    RegisterSessionComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    RegisterSessionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            _this.query = params['courseId'] || 0;
            if (_this.query != '0') {
                _this.dashboardService.getCourse(_this.query).subscribe(function (data) {
                    console.log(data);
                    _this.courseDetail = data;
                    _this.creator = data.creator;
                    _this.startTime = data.startTime;
                    _this.endTime = data.endTime;
                    _this.countryArr = _this.paymentHelper.paypalCountries();
                    if (localStorage.getItem('timezone')) {
                        _this.timezone = localStorage.getItem('timezone');
                    }
                    _this.courseDetail.displayStartDateOnlyConverted = _this.timeZoneConverstionService.convertTimezone(_this.timezone, 'date', _this.courseDetail.courseStartDTime);
                    _this.courseDetail.timeZoneConverted = _this.timezone;
                    _this.courseDetail.displayStopDateOnlyConverted = _this.timeZoneConverstionService.convertTimezone(_this.timezone, 'date', _this.courseDetail.courseEndDTime);
                    //call the loginService
                    _this.loginService.userCountry().subscribe(function (result) {
                        var country_name = result.country_name;
                        console.log('user country ' + country_name);
                        for (var i = 0, len = _this.countryArr.length; i < len; i++) {
                            var country = _this.countryArr[i];
                            //check name and user country name
                            if (country.name.toUpperCase() === country_name.toUpperCase()) {
                                _this.country = country.code;
                                console.log('Loop is going to break. for ' + country_name);
                                break;
                            }
                        }
                    }, function (error) {
                        console.log('user country retrieval service failed!!! with ' + error);
                    });
                }, function (error) {
                    if (error.Uvsity_Errors) {
                        _this.msgTitle = "Error";
                        _this.msgContent = error.Uvsity_Errors;
                        _this.popUp = true;
                    }
                });
            }
        });
    };
    RegisterSessionComponent.prototype.isArray = function (value) {
        return value && typeof value === 'object' && value.constructor === Array;
    };
    RegisterSessionComponent.prototype.closeErrorPopup = function () {
        this.showOnlyOverlay = false;
        this.showErrorMessageTitle = 'Info!!';
        this.showErrorMessages.push("Please wait... Authenticating...");
        this.isValidationError = false;
        this.showErrorPopupWidthInPercentage = "100%";
        this.showErrorModalDialog = false;
        this.isSignUp = false;
        this.pleaseWait = false;
    };
    RegisterSessionComponent.prototype.paypalPay = function (id) {
        var _this = this;
        if (this.acceptTC == false) {
            this.msgTitle = "Validation Error!!";
            this.msgContent = "Please accept the Terms & Conditions";
            this.popUp = true;
            return;
        }
        this.showOnlyOverlay = true;
        this.showErrorMessageTitle = 'Info!!';
        this.showErrorMessages.push("Please wait... Processing payment...");
        this.isValidationError = false;
        this.showErrorPopupWidthInPercentage = "100%";
        this.showErrorModalDialog = true;
        this.isSignUp = true;
        this.pleaseWait = true;
        this.loading = true;
        // this.msgTitle = "Please Wait!!";
        // this.msgContent = "Processing Payment...";
        // this.popUp = true;
        if (this.courseDetail.cost) {
            var url = location.href;
            var redirect_url = process.env.HOST_URL + "?accessPage=dashboard/myenrollment";
            var query = "?id=" + id + "&country=" + this.country + "&return_url=" + redirect_url;
            if (this.isPromoCode) {
                query = query + "&couponCode=" + this.couponCode;
            }
            this.dashboardService.registerQuestionnairePaypal(query, this.questionnaireResponse).subscribe(function (data) {
                console.log(data);
                if (data.status == 'REDIRECT') {
                    _this.closeErrorPopup();
                    window.location.href = data.approval_url;
                    _this.loading = false;
                }
                else {
                    _this.closeErrorPopup();
                    _this.msgTitle = "Error!!";
                    _this.msgContent = data.errorMsg;
                    _this.popUp = true;
                }
            }, function (error) {
                if (error.Uvsity_Errors) {
                    _this.msgTitle = "Error";
                    _this.msgContent = error.Uvsity_Errors;
                    _this.popUp = true;
                }
                _this.loading = false;
            });
        }
        else {
            this.loading = true;
            this.dashboardService.registerCourseFree(id).subscribe(function (data) {
                console.log(data);
                _this.loading = false;
                if (data.errorMsg == null) {
                    _this.router.navigate(['dashboard/myenrollment']);
                }
                else {
                    _this.msgTitle = "Error!!";
                    _this.msgContent = data.errorMsg;
                    _this.popUp = true;
                }
            }, function (error) {
                if (error.Uvsity_Errors) {
                    _this.msgTitle = "Error";
                    _this.msgContent = error.Uvsity_Errors;
                    _this.popUp = true;
                }
                _this.loading = false;
            });
        }
    };
    RegisterSessionComponent.prototype.couponKeyUp = function () {
        this.couponError = false;
        this.couponInvalid = false;
    };
    RegisterSessionComponent.prototype.applyCoupon = function () {
        var _this = this;
        this.couponError = false;
        this.couponInvalid = false;
        if (this.couponCode != "") {
            this.loading = true;
            this.dashboardService.applyCoupon(this.couponCode, this.courseDetail.courseId).subscribe(function (data) {
                console.log(data);
                _this.loading = false;
                if (data.errorMsg == null) {
                    if (data.success) {
                        _this.couponData = data;
                        _this.isPromoCode = true;
                    }
                    else {
                        _this.couponInvalid = true;
                    }
                }
                else {
                    _this.msgTitle = "Error!!";
                    _this.msgContent = data.errorMsg;
                    _this.popUp = true;
                }
            }, function (error) {
                if (error.Uvsity_Errors) {
                    _this.msgTitle = "Error";
                    _this.msgContent = error.Uvsity_Errors;
                    _this.popUp = true;
                }
                _this.loading = false;
            });
        }
        else {
            this.couponError = true;
        }
    };
    RegisterSessionComponent.prototype.removePromo = function () {
        this.isPromoCode = false;
        this.couponError = false;
        this.couponInvalid = false;
        this.couponCode = "";
        this.couponData.revisedAmount = 0;
        this.couponData.success = false;
    };
    RegisterSessionComponent.prototype.validateCardNumber = function () {
        if (this.details.card_number === undefined || this.details.card_number === "") {
            console.log('no need to validate an empty creditcard');
            return;
        }
        if (!this.paymentHelper.isValid(this.details.card_number)) {
            this.loading = false;
            this.msgTitle = "Error!!";
            this.msgContent = "Invalid Creditcard Number, please check the number";
            this.popUp = true;
        }
        else {
            this.details.type = this.getCreditCardType(this.details.card_number);
            if (this.details.type == "") {
                this.loading = false;
                this.msgTitle = "Error!!";
                this.msgContent = "Invalid Creditcard Number, please check the number";
                this.popUp = true;
            }
        }
    };
    RegisterSessionComponent.prototype.ccPay = function (id) {
        var _this = this;
        if (this.acceptTC == false) {
            this.msgTitle = "Validation Error!!";
            this.msgContent = "Please accept the Terms & Conditions";
            this.popUp = true;
            return;
        }
        this.msgTitle = "Please Wait!!";
        this.msgContent = "Processing Payment...";
        this.popUp = true;
        this.loading = true;
        if (this.courseDetail.cost) {
            this.details.id = id.toString();
            this.details.country_code = this.country;
            this.details.type = this.getCreditCardType(this.details.card_number);
            console.log(this.details.type);
            if (this.details.type == "") {
                this.loading = false;
                this.msgTitle = "Error!!";
                this.msgContent = "Invalid Creditcard Number, please check the number";
                this.popUp = true;
            }
            else {
                this.dashboardService.registerCC(this.details).subscribe(function (data) {
                    console.log(data);
                    if (data.errorMsg == null) {
                        _this.loading = false;
                        _this.router.navigate(['dashboard/myenrollment']);
                    }
                    else {
                        _this.msgTitle = "Error!!";
                        _this.msgContent = data.errorMsg;
                        _this.popUp = true;
                        _this.loading = false;
                    }
                }, function (error) {
                    if (error.Uvsity_Errors) {
                        _this.msgTitle = "Error";
                        _this.msgContent = error.Uvsity_Errors;
                        _this.popUp = true;
                    }
                    _this.loading = false;
                });
            }
        }
        else {
            this.dashboardService.registerCourseFree(id).subscribe(function (data) {
                console.log(data);
                if (data.errorMsg == null) {
                    _this.router.navigate(['dashboard/myenrollment']);
                }
                else {
                    _this.msgTitle = "Error!!";
                    _this.msgContent = data.errorMsg;
                    _this.popUp = true;
                    _this.loading = false;
                }
            }, function (error) {
                if (error.Uvsity_Errors) {
                    _this.msgTitle = "Error";
                    _this.msgContent = error.Uvsity_Errors;
                    _this.popUp = true;
                }
                _this.loading = false;
            });
        }
    };
    RegisterSessionComponent.prototype.getCreditCardType = function (number) {
        //start without knowing the credit card type
        var re = new RegExp("^4");
        if (number.match(re) != null)
            return "visa";
        // Mastercard 
        // Updated for Mastercard 2017 BINs expansion
        if (/^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(number))
            return "mastercard";
        // AMEX
        re = new RegExp("^3[47]");
        if (number.match(re) != null)
            return "amex";
        // Discover
        re = new RegExp("^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)");
        if (number.match(re) != null)
            return "discover";
        // Diners
        re = new RegExp("^36");
        if (number.match(re) != null)
            return "diners";
        // Diners - Carte Blanche
        re = new RegExp("^30[0-5]");
        if (number.match(re) != null)
            return "diners";
        // JCB
        re = new RegExp("^35(2[89]|[3-8][0-9])");
        if (number.match(re) != null)
            return "jcb";
        // Visa Electron
        re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
        if (number.match(re) != null)
            return "visa";
        return "";
    };
    return RegisterSessionComponent;
}());
export { RegisterSessionComponent };
//# sourceMappingURL=registersession.component.js.map